import SectorViewDialog from './SectorViewDialog';

export default SectorViewDialog ;